// extracted by mini-css-extract-plugin
export default {"calendar":"DatePicker_calendar__1kzuU","InputWrapper":"DatePicker_InputWrapper__CFrnE","input":"DatePicker_input__1sOSo","img":"DatePicker_img__LF38C"};